import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SearchState {
    search: {
        token: string | null;
        card: string | null;
        transactionDate: Date | null;
        stationNo: string | null;
        step: number | null;
    };
}

const initialState: SearchState = {
    search: {
        token: null,
        card: null,
        transactionDate: null,
        stationNo: null,
        step: 0,
    },
};

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setSearch: (state, { payload }: PayloadAction<SearchState>) => {
            state.search = payload.search;
        },
        resetSearch: () => initialState,
    },
});

export const searchReducer = searchSlice.reducer;
export const { setSearch, resetSearch } = searchSlice.actions;
